<template>
  <div>
    <LsInputLabel
      v-if="label"
      :label="label"
      :sub-label="subLabel"
      :collapse-content="collapseContent"
    />
    <BField :type="{ 'is-error': getValidation.invalid }" :message="getValidation.message">
      <section :class="{ 'ls-radios--section': columns }">
        <div v-for="option in options" :key="option.key || option.label" class="field">
          <BRadio
            v-model="localValue"
            v-validate="validation"
            :name="name"
            :native-value="option.value"
            :disabled="option.disabled || disabled"
            :class="{ 'raw-style': rawStyle }"
            test-id="ls-radio"
          >
            <template v-if="!itemComponent">
              <p :class="{ bold: option.boldLabel }">{{ option.label }}</p>
              <p v-if="option.subLabel" test-id="sub-label" class="ls-radios--sub-label">
                {{ option.subLabel }}
              </p>
            </template>

            <template v-else>
              <component :is="itemComponent" v-bind="option"> <slot /> </component>
            </template>
          </BRadio>
        </div>
      </section>
    </BField>
  </div>
</template>

<script>
import { lsPropTypeHelpers, lsTrackingService, lsValidationService } from 'ls-vue-common';
import VueTypes from 'vue-types';
import _ from 'lodash';
import { LsInputLabel } from '@/components/common';

export default {
  name: 'LsRadios',
  inject: ['$validator'],
  components: {
    LsInputLabel,
  },
  props: {
    value: VueTypes.any.isRequired,
    trackId: VueTypes.custom(lsPropTypeHelpers.trackID).isRequired,
    name: VueTypes.string.isRequired,
    options: VueTypes.arrayOf(
      VueTypes.shape({
        label: VueTypes.string.isRequired,
        value: VueTypes.any.isRequired,
        subLabel: VueTypes.string.def(''),
        boldLabel: VueTypes.bool.def(false),
        disabled: VueTypes.bool,
        key: VueTypes.oneOfType([String, Number]),
        bundle: VueTypes.object.def({}),
        default: VueTypes.bool,
      })
    ).isRequired,
    label: VueTypes.string,
    subLabel: VueTypes.string,
    collapseContent: VueTypes.string,
    disabled: VueTypes.bool.def(false),
    validation: VueTypes.object.def(_.constant(null)),
    columns: VueTypes.bool.def(false),
    itemComponent: {
      type: [String, Object],
      default: null,
    },
    rawStyle: VueTypes.bool.def(false),
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        lsTrackingService.track({
          event: 'click',
          target: this.trackId,
          data: { value },
        });
        this.$emit('input', value);
      },
    },
    getValidation() {
      return lsValidationService.getValidation.call(this);
    },
  },
};
</script>

<style lang="scss">
@media (min-width: $desktop) {
  .ls-radios--section {
    display: flex;
    flex-wrap: wrap;
    div {
      flex: 50%;
      min-width: 50%;
    }
  }
}

.ls-radios--sub-label {
  font-size: $size-6;
}

.b-radio {
  .control-label {
    padding-left: $size-6 !important;
  }

  .check {
    border: 1px solid $gray-tertiary !important;
  }

  &.radio[disabled] {
    .check {
      cursor: not-allowed !important;
    }
  }
}

.bold {
  font-weight: bold;
}

.raw-style {
  margin: 0 0 1.25rem 0;

  .check {
    align-self: flex-start;
  }

  &.radio[disabled] {
    opacity: 1;
  }

  &.radio:not(.button) {
    margin: 0;
  }
}

.themed-app {
  .b-radio.radio input[type='radio'] + .check:before {
    background-color: $theme-color-primary;
  }
}
</style>
